import { FormattedMessage } from 'react-intl';

import { TwcOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { Headings } from '../../components/headings';
import { SwitchYourSiteMessage } from '../components/switch-your-site-message';

export const CrossflowEligibleUser = () => {
	const headingText = (
		<FormattedMessage
			id="signup.teamworkCollection.uplift.heading"
			defaultMessage="Switch your site to Teamwork Collection"
		/>
	);

	return (
		<TwcOverlayTemplate size="sm">
			<Headings main={headingText} />
			<SiteActivation CrossflowEligibleUser={<SwitchYourSiteMessage />} />
		</TwcOverlayTemplate>
	);
};
